// extracted by mini-css-extract-plugin
export default {"formTitleContainer":"FormTitle_formTitleContainer__CvI0v"};